import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FairValueAndPpChartsService } from '../service/calculations-service/fair-value-and-pp-charts.service';
import { ExcelService } from 'src/app/domain/excel';
import { ExcelTemplateName } from 'src/app/domain/excel/interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyBackendService } from '../../../../pp/service/company-backend.service';
import { CompanyDto } from '../../../../recovery/component/recovery-company/dto/CompanyWithOrgDto';
import { HorNavbarService } from "../../../../../core/service/hor-navbar.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { SwitcherNumberType } from "../../../../../core/component/numberswitcher/utils/number-switcher-common-classes";
import { CP_URLS } from '../../../../company-performance/dto/CP_URLS';
import { PpUrlService } from '../../../../pp/service/pp-url.service';
import { FP_URLS_FULL_PATH } from '../../../../fund-performance/component/fund-performances/pojo/FP_URLS';
import { PP_URLS } from '../../../../pp/component/base/dto/PpTab';
import { DataBehindTable, DATA_BEHIND_SORT, DATA_BEHIND_COMPANIES_SORT, FvAndPpChartsTableData, GroupedPortfolioExcelWrapper } from '../pojo/fmv-charts-classes';
import { GroupedPortfolio } from '../../../../chart/ChartAuxiliary';

@Component({
  selector: 'app-data-behind-fv-and-pp-charts',
  templateUrl: './data-behind-fv-and-pp-charts.component.html',
  styleUrls: ['./data-behind-fv-and-pp-charts.component.scss'],
})
export class DataBehindFvAndPpChartsComponent implements OnChanges {

  @Input() rawData: GroupedPortfolio;
  @Input() categoryName: string;
  @Input() selectedOrgName: string;
  @Input() isOnlyCompanies = false;
  data = new DataBehindTable();
  numberSwitcher: SwitcherNumberType = SwitcherNumberType.REGULAR;
  show = {
    table: false, // show or hide the whole table
    row: [] as boolean[], // show or hide selected row
  };

  readonly sortDataBehindFvAndPP = DATA_BEHIND_SORT;
  readonly dataBehindCompaniesSort = DATA_BEHIND_COMPANIES_SORT;

  constructor(
    private router: Router,
    private excelService: ExcelService,
    private route: ActivatedRoute,
    private companyService: CompanyBackendService,
    private horNavbarService: HorNavbarService,
    private ppUrlService: PpUrlService,
  ) {
    this.horNavbarService.getNumberSwitcher.pipe(takeUntilDestroyed()).subscribe((ns) => this.numberSwitcher = ns);
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rawData) {
      this.data = FairValueAndPpChartsService.processDataBehindTable(this.rawData, this.isOnlyCompanies);
      this.show.row.push(this.isOnlyCompanies);
    }
  }

  async goToCompanyPage(company: FvAndPpChartsTableData): Promise<void> {
    const companyDto: CompanyDto = await this.companyService.getById(company.companyData.id);
    const url = `${CP_URLS.BASE}/${companyDto.uuid}`;
    this.ppUrlService.setPrevURL(FP_URLS_FULL_PATH.FUND + '/' + PP_URLS.base + '/' + PP_URLS._overview);
    this.router.navigate([url], { queryParams: this.route.snapshot.queryParams });
  }

  exportExcel(): void {
    const fileName = this.selectedOrgName + '-by-' + this.categoryName + '-data-behind.xlsx';
    const data: GroupedPortfolioExcelWrapper = {
      rawData: this.data,
      categoryName: this.categoryName,
      isOnlyCompanies: this.isOnlyCompanies,
    };
    this.excelService.exportByTemplate(data, fileName, ExcelTemplateName.dataBehindFvOpChart);
  }
}

export { GroupedPortfolioExcelWrapper, FvAndPpChartsTableData, DataBehindTable };

